import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, Validator } from '@angular/forms';

@Directive({
  selector: '[appConfirmPasswordValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: ConfirmPasswordValidatorDirective, multi: true}]
})
export class ConfirmPasswordValidatorDirective implements Validator{

  @Input('appConfirmPasswordValidator') sameAsControl: string;

  validate(control: AbstractControl): {[key: string]: any} {
    const otherControl = control.root.get(this.sameAsControl);
    return otherControl.value != control.value ? {'sameAsControl': {value: control.value}} : null;
  }
}
